import React, { useEffect, useState, useContext } from 'react'
import axios from "axios";
import { getBaseUrl } from "../utils";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { X } from 'lucide-react';
import AgoraCall from "./AgoraCall";
import { UserContext } from './UserContext';

const CounsellingDeatil = () => {
    const { subscription } = useContext(UserContext);
    console.log('subcription from counselling => ', subscription);

    const navigate = useNavigate();

    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const location = useLocation();
    const receivedData = location.state?.data;

    const [activeTab, setActiveTab] = useState('Consultants');
    const tabs = ['Consultants', 'History'];
    const [OpenPopup, setOpenPopup] = useState(false);
    const handleButtonClick = () => {
        setOpenPopup(!OpenPopup);
    }
    const [SubmitData, setSubmitData] = useState(false)
    const [ratingModel, setRatingModel] = useState(false)

    const [selectedDate, setSelectedDate] = useState('');
    const [slots, setSlots] = useState([]);
    const [selectedTime, setSelectedTime] = useState('');
    const [selectedConsultationType, setSelectedConsultationType] = useState('');

    // Fetch available slots when date is selected
    useEffect(() => {
        if (selectedDate) {
            fetchSlots(selectedDate);
        }
    }, [selectedDate]);

    const checkCounsellingAccess = () => {
        if (!subscription?.features?.counselling_enabled) {
            toast.error("Your current subscription does not allow counselling.");
            return false;
        }

        const allowedLimit = subscription.features.counselling || 0;

        // Count total bookings (you can adjust this logic if needed)
        const totalUsed = [...upcomingSessions, ...history].length;

        if (totalUsed >= allowedLimit) {
            toast.error(`Your plan allows only ${allowedLimit} counselling sessions. Upgrade your plan.`);
            return false;
        }

        return true;
    };

    const fetchSlots = async (date) => {
        try {
            console.log("API hit----->");
            console.log("date----->", date);
            const response = await axios.get(`${baseUrl}user_api/consultantsList?bookingDate=${date}&search&page=1&limit=10&consultantsId=${receivedData._id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            console.log("Extracted slots:", response.data);
            if (response.data.status) {
                console.log("Extracted slots:", response.data.results[0].slots);

                setSlots(response.data.results[0].slots || []);
            }
        } catch (error) {
            console.error("Error fetching slots:", error);
        }
    };

    const handleSubmit = async () => {
        if (selectedDate && selectedTime && selectedConsultationType) {
            const formData = {
                adminId: receivedData._id,
                sloteId: selectedTime,  // Make sure this contains the correct slot `_id`
                date: selectedDate,
                user_comment: "",
                type: selectedConsultationType,
            };

            console.log('Form Submitted:', formData);

            try {
                console.log("formData----->", formData);
                const response = await axios.post(`${baseUrl}user_api/booking`,
                    formData,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Change to JSON
                        },
                    }
                );

                console.log("booking----------------------------------------------->:", response.data.results);
                if (response.data.status) {
                    setLast_bookingId(response.data.results._id)
                    setSubmitData(true);
                    setOpenPopup(false);
                    fetchUpcomingSessions();
                    // Reset form fields
                    setSlots([])
                    setSelectedDate("");
                    setSelectedTime(null);
                    setSelectedConsultationType("");
                    setRatingModel(true)

                }
            } catch (error) {
                console.error("Error submitting booking:", error);
            }
        } else {
            alert('All fields are required');
        }
    };

    const handleTimeSelection = (time) => {
        setSelectedTime(time);
    };
    const handleConsultationType = (type) => {
        setSelectedConsultationType(type);
    };
    const handleDone = () => {
        setSubmitData(false);
    };
    const Close__button = () => {
        setSelectedDate('')
        setSlots([])
        setSelectedTime('')
        setSelectedConsultationType('')

        setOpenPopup(false);
    };

    const [upcomingSessions, setUpcomingSessions] = useState([]);

    useEffect(() => {
        fetchUpcomingSessions();
    }, []);

    const fetchUpcomingSessions = async () => {
        try {
            const response = await axios.get(`${baseUrl}user_api/bookingList?page=1&limit=10&status=Pending`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.status && response.data.results.length > 0) {
                setUpcomingSessions(response.data.results); // Store all upcoming sessions
            } else {
                setUpcomingSessions([]);
            }
        } catch (error) {
            console.error('Error fetching upcoming sessions:', error);
        }
    };
    console.log('upcomingSessions:', upcomingSessions);


    const [history, sehistory] = useState([]);

    useEffect(() => {
        fetchsehistory();
    }, []);

    const fetchsehistory = async () => {
        try {
            const response = await axios.get(`${baseUrl}user_api/bookingList?page=1&limit=10&statusArray=Reject,Approve,Complete`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            console.log("response----->", response);
            if (response.data.status && response.data.results.length > 0) {
                sehistory(response.data.results); // Store all upcoming sessions
            } else {
                sehistory([]);
            }
        } catch (error) {
            console.error('Error fetching upcoming sessions:', error);
        }
    };
    console.log('history:', history);

    const [rating, setRating] = useState(0);
    const [message, setMessage] = useState('');
    const [last_bookingId, setLast_bookingId] = useState('');

    const onClose = () => {
        setRatingModel(false);
    };
    async function onSubmitrating(rating, message) {
        console.log('Form last_bookingId:', last_bookingId);
        console.log('Form rating:', rating);
        console.log('Form message:', message);


        if (rating && message && last_bookingId) {
            const formData = {
                rating: rating,
                comment: message,
                bookingId: last_bookingId,
            };

            console.log('Form Submitted:', formData);

            try {
                console.log("formData----->", formData);
                const response = await axios.post(`${baseUrl}user_api/addRating`,
                    formData,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json', // Change to JSON
                        },
                    }
                );

                console.log("booking:", response.data);
                if (response.data.status) {
                    setMessage("");
                    setRating(0);
                    setRatingModel(false)

                }
            } catch (error) {
                console.error("Error submitting booking:", error);
            }
        } else {
            alert('All fields are required');
        }
    }

    const handleAttemptClick = () => {
        console.log("Button Clicked");
        
        if (!selectedDate) {
            toast.error("Please select a date");
            return;
        }

        if (!selectedTime) {
            toast.error("Please select a time slot");
            return;
        }

        if (!selectedConsultationType) {
            toast.error("Please select consultation type");
            return;
        }

        // 🔥 SUBSCRIPTION CHECK
        const hasAccess = checkCounsellingAccess();
        if (!hasAccess) return;

        // ✅ Direct booking (NO PAYMENT)
        handleSubmit();
    };
    return (
        <div>

            <ToastContainer />

            <section className="bg-[#F2F2F2] pt-[30px]">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <div className="tab-navigation flex gap-[50px] Paragraph__etxt">
                                {tabs.map((tab) => (
                                    <div
                                        key={tab}
                                        className={`tab ${activeTab === tab ? 'active' : 'inactive'}`}
                                        onClick={() => setActiveTab(tab)}
                                    >
                                        {tab}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
 {/*<div className='text-center Paragraph__etxt'>*/}
                                                {/*    <h4 className='font-bold ' style={{ fontSize: '20px' }}>Rs.{receivedData.sessionPrice || '0'}</h4>*/}
                                                {/*    <label>per session</label>*/}
                                                {/*</div>*/}
                                        {/* <img src={'/assates/Detail__images.png'} alt='images' /> */}

                    {activeTab === 'Consultants' && (
                        <div className="container-fluid bg-[#F2F2F2]">
                            <div className="row">
                                <div className="col-sm-8 p-0 m-0">
                                    <div>
                                       <div className="w-full flex justify-center">
    <img
        src={receivedData.profile_img}
        alt={receivedData.name}
        className="w-full max-w-[320px] h-[320px] md:max-w-[360px] md:h-[420px] object-cover rounded-2xl shadow-lg"
    />
</div>

                                        <div className='sm:flex justify-between  pt-4 items-center'>
                                            <div className='Paragraph__etxt '>
                                                <h4 className='font-bold' style={{ fontSize: '20px' }}>{receivedData.name || ''}</h4>
                                                <label style={{ fontSize: '15px' }}>Expertise: {receivedData.subjectNames || ''}</label><br></br>
                                                <label style={{ fontSize: '15px' }}>{receivedData.experience || '0'} Years of Experience</label>
                                            </div>
                                            <div className='flex items-center gap-4'>
                                               
                                                <button className='bg-[#28282B] text-white border-2 transition-all duration-300 ease-in-out px-4 py-2 rounded-lg' onClick={handleButtonClick}>Book Now</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='pt-3 Header__text font-semibold' style={{ fontSize: '20px' }}>
                                        <h3>About Consultant:</h3>
                                        <p className='Paragraph__etxt font-[400]'>{receivedData.about || ''}</p>
                                    </div>

                                    <div className='pt-3 Header__text font-semibold' style={{ fontSize: '20px' }}>
                                        <h3>Ratings:</h3>
                                        <div className='sm:flex'>
                                            {receivedData.ratings.length > 0 ? (
                                                receivedData.ratings.map((items, index) => (
                                                    <div className='pt-3'>
                                                        <div className='flex gap-2'>
                                                            <img src={items.userImage || '/assates/Detail__testimonial__images.png'} alt='images' />
                                                            <div>
                                                                <h5 className='font-[600]' style={{ fontSize: '15px' }}>{items.userName}</h5>
                                                                <div className='flex text-orange-500 text-[15px]'>
                                                                    {Array.from({ length: items.rating }, (_, i) => (
                                                                        <i key={i} className="ri-star-s-fill"></i>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p className='Paragraph__etxt font-[400]'>{items.comment} </p>
                                                    </div>
                                                ))
                                            ) : (
                                                <h5 className='Header__text font-medium pb-4' style={{ fontSize: '20px' }}>No Ratings Found!</h5>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-4 pl-0 md:pl-2 pr-0">
                                    <div className="pt-1 md:pl-1 pb-1 pr-0">
                                        <div className="bg-black p-2 rounded-bl-lg rounded-tl-lg rounded-lg">
                                            <div>
                                                <label className="text-white">Upcoming Session</label>
                                                {upcomingSessions.length > 0 ? (
                                                    upcomingSessions.map((session, index) => (
                                                        <div key={index} className="mt-4">
                                                            <div className="flex bg-white items-center gap-2 w-[110px] justify-center rounded-tl-lg rounded-tr-lg">
                                                                <i className="ri-vidicon-fill"></i>
                                                                <label>{session.type}</label>
                                                            </div>
                                                            <div

                                                                className="bg-white p-2 pt-3 flex items-center gap-2 rounded-bl-lg rounded-br-lg rounded-tr-lg">
                                                                <img
                                                                    src={session.adminDetails[0].profile_img || "/assates/counselling__images.png"}
                                                                    alt="Consultant"
                                                                    className="w-12 h-12 rounded-full object-cover"
                                                                />
                                                                <div>
                                                                    <label className="Paragraph__etxt font-bold">{session.adminName}</label>
                                                                    <div style={{ fontSize: '13px' }}>Expertise: {session.adminDetails[0].experience}</div>
                                                                    <div style={{ fontSize: '13px' }} className="text-gray-400">{session.date} | {session.slotTime}</div>
                                                                    <button
                                                                        style={{ fontSize: '13px' }}
                                                                        onClick={() => {
                                                                            let path = `/call/${session.channelId}`; // Default to Video
                                                                            if (session.type === 'Audio') path = `/audio_call/${session.channelId}`;
                                                                            else if (session.type === 'Chat') path = `/chat/${session.userId}/${session.adminId}`;

                                                                            navigate(path);
                                                                        }}
                                                                    >
                                                                        Connect
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-white text-center mt-3">No Upcoming Sessions</div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'History' && (
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 bg-white p-0 m-0 rounded-tl-xl rounded-tr-xl">
                                    <div className="w-full overflow-x-auto">
                                        <div className="bg-[#F0F0F0] Paragraph__etxt font-[700] flex p-3 rounded-tr-xl rounded-tl-xl min-w-[700px]" style={{ fontSize: '14px' }}>
                                            <div className="w-[100px]">S.No</div>
                                            <div className="w-[100px]">ID</div>
                                            <div className="w-[200px] flex items-center justify-center">Consultant Name</div>
                                            <div className="w-[150px] flex items-center justify-center">Type</div>
                                            <div className="w-[150px] flex items-center justify-center">Expertise</div>
                                            <div className="w-[200px] flex items-center justify-center">Date & Time</div>
                                            <div className="w-[150px] flex items-center justify-center">Status</div>
                                        </div>
                                    </div>

                                    {history.length > 0 ? (
                                        history.map((hs, index) => (
                                            <div className="border-b bg-white Paragraph__etxt font-[400] flex justify-between bg-[#F0F0F0] p-3 rounded-tr-xl rounded-tl-xl" style={{ fontSize: '14px' }}>
                                                <div className="w-full">1.</div>
                                                <div className="w-full">{hs._id.slice(-5)}</div>
                                                <div className="w-full flex items-center justify-center">{hs.adminName}</div>
                                                <div className="w-full flex items-center justify-center">{hs.type}</div>
                                                <div className="w-full flex items-center justify-center">{hs.adminDetails[0].experience}</div>
                                                <div className="w-full flex items-center justify-center">{hs.date} | {hs.slotTime}</div>
                                                <div
                                                    className={`w-full flex items-center justify-center pt-1 pb-1 rounded-sm text-white 
                                                                ${hs.status === "Complete" ? "bg-blue-500" :
                                                                hs.status === "Reject" ? "bg-red-500" :
                                                                hs.status === "Approve" ? "bg-green-500" : "bg-gray-400"}`}>
                                                    {hs.status}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-white text-center mt-3">No Upcoming Sessions</div>
                                    )}

                                </div>


                            </div>
                        </div>
                    )}
                </div>
            </section>
            {/* Pupop sectio coding start */}
            {OpenPopup && (
                <div className="popup">
                    <div className="popup-content">
                        <div className='header bg-black rounded-tl-lg rounded-tr-lg text-white p-3 relative '>
                            <h6>Book Session</h6>
                            <i className="ri-close-circle-line absolute top-4 text-[17px] right-3" onClick={Close__button}></i>
                        </div>
                        <div className='items-start flex flex-col pl-4 pr-4 pb-4'>
                            <label className='pt-3 pb-3'>Book your session</label>
                            <input
                                type="date"
                                id="birthday"
                                name="birthday"
                                className='w-full p-2 rounded-lg'
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                            <div>
                                <div className="flex w-full justify-between gap-2">
                                    {slots.length > 0 ? (
                                        slots.map((slot) => (
                                            <div
                                                key={slot._id}
                                                className={`border p-2 rounded-lg mt-3 cursor-pointer 
                    ${slot.disabled ? 'bg-gray-300 text-gray-500 cursor-not-allowed' :
                                                        selectedTime === slot._id ? 'bg-gray-800 text-white' : 'bg-white'}`}
                                                onClick={() => !slot.disabled && handleTimeSelection(slot._id)}
                                            >
                                                <h1>{slot.time}</h1>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-red-500">No slots available</p>
                                    )}
                                </div>
                                <h3 className="pt-2 Paragraph__etxt font-bold pb-2 text-left">Choose Consultation Type</h3>
                                <div className="w-full flex justify-between gap-2">
                                    <button
                                        className={`border border-red pt-1 pb-1 rounded-lg pl-4 pr-4 ${selectedConsultationType === 'Video' ? 'bg-gray-800 text-white' : 'bg-white'}`}
                                        onClick={() => handleConsultationType('Video')}
                                    >
                                        <i className="ri-vidicon-fill"></i> Video
                                    </button>
                                    <button
                                        className={`border border-red pt-1 pb-1 rounded-lg pl-4 pr-4 ${selectedConsultationType === 'Audio' ? 'bg-gray-800 text-white' : 'bg-white'}`}
                                        onClick={() => handleConsultationType('Audio')}
                                    >
                                        <i className="ri-phone-fill"></i> Audio
                                    </button>

                                    <button
                                        className={`border border-red pt-1 pb-1 rounded-lg pl-4 pr-4 ${selectedConsultationType === 'Chat' ? 'bg-gray-800 text-white' : 'bg-white'}`}
                                        onClick={() => handleConsultationType('Chat')}
                                    >
                                        <i className="ri-phone-fill"></i> Chat
                                    </button>
                                </div>
                            </div>
                            <button className='bg-black w-full mt-3 p-2 rounded-lg text-white' onClick={handleAttemptClick}>
                                Book Now
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {
                SubmitData && (
                    <div className="Submit__data__popupop">

                        <div className="Submit__pupop__content">

                            <div className='items-start flex flex-col pl-4 pr-4 pb-4'>
                                <center>
                                    <img src='/assates/Submit_images.png' alt='images' />
                                    <label className='text-white font-bold pt-2'>Congratulations!</label> <br></br>
                                    <lebel className='text-white Paragraph__etxt'>Your Booking request has been confirmed.</lebel>
                                    <button onClick={handleDone} className='bg-white w-full mt-3 p-2 rounded-lg'>Done</button>
                                </center>
                            </div>

                        </div>


                    </div>
                )
            }




            {
                ratingModel && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white w-80 p-6 rounded-lg shadow-lg relative">
                            <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800">
                                <X size={18} />
                            </button>
                            <h2 className="text-lg font-semibold text-gray-900 text-center">Rate your experience</h2>
                            <p className="text-sm text-gray-600 text-center mt-2">How easy or difficult was it to use our website?</p>

                            <div className="flex justify-center mt-3">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                        key={star}
                                        className={`cursor-pointer text-2xl ${star <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
                                        onClick={() => setRating(star)}
                                    >
                                        ★
                                    </span>
                                ))}
                            </div>

                            <div className="mt-4">
                                <label className="block text-sm text-gray-700">Message</label>
                                <textarea
                                    className="w-full p-2 border border-gray-300 rounded-md mt-1"
                                    placeholder="Enter your message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                            </div>
                            <button
                                className="bg-black text-white w-full py-2 mt-4 rounded-md hover:bg-gray-800"
                                onClick={() => onSubmitrating(rating, message)}
                            >
                                SEND
                            </button>
                        </div>
                    </div>
                )
            }




        </div>
    )
}

export default CounsellingDeatil





